var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 40,
    viewBox: "0 0 216 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1113_1387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.0321 24.2322C76.3822 24.2322 75.7734 23.5055 75.7734 22.3467C75.7734 21.0112 76.5197 20.3237 78.4641 20.3237H81.0371V21.0897C81.0371 23.1323 79.7801 24.2322 78.0321 24.2322ZM73.554 22.5628C73.554 24.1537 74.4771 25.8624 77.3643 25.8624C79.0337 25.8624 80.1925 25.2143 80.9978 24.1929L81.2728 25.6071H83.0797V17.9865C83.0797 14.7262 81.1353 14.1566 78.8177 14.1566C77.0697 14.1566 74.7717 14.6672 74.2218 17.2991H76.4412C76.7161 16.317 77.3839 15.7475 78.798 15.7475C79.9568 15.7475 81.0567 16.1599 81.0567 18.0061V18.8114H78.6213C75.6752 18.8114 73.554 19.7934 73.554 22.5628ZM67.6814 25.6071H69.7633V18.615C69.7633 16.9848 70.765 16.2581 72.0417 16.2581C72.4738 16.2581 72.9255 16.2778 73.3772 16.3563V14.3137C72.9844 14.1762 72.6309 14.1566 72.2773 14.1566C71.1185 14.1566 70.2151 14.844 69.7633 15.8064L69.508 14.4512H67.6814V25.6071ZM141.53 25.6071H143.612V18.615C143.612 16.9848 144.614 16.2581 145.89 16.2581C146.323 16.2581 146.774 16.2778 147.226 16.3563V14.3137C146.833 14.1762 146.48 14.1566 146.126 14.1566C144.967 14.1566 144.064 14.844 143.612 15.8064L143.357 14.4512H141.53V25.6071ZM102.386 16.2581V14.4315H100.108V11.2498L97.9673 11.5837V14.4315H96.3568V16.2581H97.9673V23.368C97.9673 24.9589 98.5565 25.9213 100.894 25.9213C101.404 25.9213 102.17 25.8231 102.642 25.6856V24.0947C102.151 24.2322 101.699 24.2519 101.365 24.2519C100.383 24.2519 100.108 23.7805 100.108 22.7592V16.2778H102.386V16.2581ZM165.197 16.2581V14.4315H162.899V11.2498L160.778 11.5837V14.4315H159.168V16.2581H160.778V23.368C160.778 24.9589 161.367 25.9213 163.705 25.9213C164.215 25.9213 164.981 25.8231 165.453 25.6856V24.0947C164.962 24.2322 164.51 24.2519 164.176 24.2519C163.194 24.2519 162.919 23.7805 162.919 22.7592V16.2778H165.197V16.2581ZM134.165 24.1537C132.162 24.1537 130.865 22.7592 130.865 19.9898C130.865 17.3384 132.201 15.8457 134.185 15.8457C136.188 15.8457 137.366 17.3187 137.366 20.1077C137.386 22.8181 136.149 24.1537 134.165 24.1537ZM171.423 24.1537C169.42 24.1537 168.124 22.7592 168.124 19.9898C168.124 17.3384 169.459 15.8457 171.443 15.8457C173.446 15.8457 174.625 17.3187 174.625 20.1077C174.644 22.8181 173.407 24.1537 171.423 24.1537ZM148.679 25.6071H150.702V19.1649C150.702 17.3187 151.508 16.0224 153.432 16.0224C155.239 16.0224 155.789 16.7884 155.789 18.6739V25.5874H157.871V18.0847C157.871 15.5118 156.791 14.1762 154.356 14.1762C152.686 14.1762 151.449 14.7851 150.702 15.8457L150.447 14.4315H148.679V25.6071ZM85.7705 25.6071H87.7935V19.1649C87.7935 17.3187 88.5987 16.0224 90.5235 16.0224C92.3304 16.0224 92.8804 16.7884 92.8804 18.6739V25.5874H94.9623V18.0847C94.9623 15.5118 93.882 14.1762 91.4466 14.1762C89.7772 14.1762 88.5398 14.7851 87.7935 15.8457L87.5381 14.4315H85.7705V25.6071ZM178.808 25.6071H180.831V19.1649C180.831 17.3187 181.636 16.0224 183.561 16.0224C185.368 16.0224 185.918 16.7884 185.918 18.6739V25.5874H188V18.0847C188 15.5118 186.92 14.1762 184.484 14.1762C182.815 14.1762 181.578 14.7851 180.831 15.8457L180.576 14.4315H178.808V25.6071ZM116.606 10.6016V8.79469H104.724V10.6016H109.575V25.5874H111.834V10.6016H116.606ZM117.687 25.6071H119.709V19.1649C119.709 17.3187 120.495 16.0224 122.44 16.0224C124.246 16.0224 124.796 16.7884 124.796 18.6739V25.5874H126.878V18.0847C126.878 15.5118 125.798 14.1762 123.363 14.1762C121.693 14.1762 120.456 14.7851 119.709 15.8457V8.81433H117.687V25.6071ZM59.3145 18.9489H63.2819V22.6806C62.0642 23.7412 60.218 24.1537 58.7253 24.1537C54.9936 24.1537 52.8724 21.7379 52.8724 17.4955C52.8724 12.9978 55.1507 10.5034 58.686 10.5034C60.7876 10.5034 62.3588 11.2498 63.8515 12.6639L65.1674 11.1712C63.8319 9.69815 61.5339 8.61792 58.9217 8.61792C53.658 8.61792 50.5352 12.2907 50.5352 17.4366C50.5352 22.4842 53.1277 25.9802 58.7646 25.9802C61.8678 25.9802 64.2836 24.625 65.4817 23.3288V17.2402H59.3342V18.9489H59.3145ZM134.322 14.1566C130.63 14.1566 128.685 16.7099 128.685 20.0684C128.685 23.5448 130.61 25.8428 134.067 25.8428C137.504 25.8428 139.645 23.5841 139.645 20.0095C139.645 16.3367 137.661 14.1566 134.322 14.1566ZM171.58 14.1566C167.868 14.1566 165.944 16.7099 165.944 20.0684C165.944 23.5448 167.868 25.8428 171.325 25.8428C174.762 25.8428 176.903 23.5841 176.903 20.0095C176.903 16.3367 174.919 14.1566 171.58 14.1566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9891 12.2753C23.1402 13.2864 25.6328 15.6145 27.3259 18.9537C27.5611 19.4005 27.6787 20.0589 27.5376 20.4587C27.5846 20.2941 27.6552 20.153 27.7022 19.9884C31.7469 7.28997 17.4259 -1.24619 10.1596 2.58685C10.0185 2.6574 9.87738 2.72795 9.73629 2.82201C0.400603 8.3952 -2.72697 20.3881 2.58755 29.8179C-1.22197 22.5516 7.29067 8.23059 19.9891 12.2753Z",
    fill: "url(#paint0_linear_1113_1387)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2762 19.9883C13.2874 16.8372 15.6154 14.3446 18.9547 12.6515C19.4014 12.4163 20.0599 12.2987 20.4596 12.4398C20.295 12.3928 20.1539 12.3222 19.9893 12.2752C7.29093 8.23054 -1.22171 22.5515 2.58781 29.8178C2.65836 29.9589 2.7289 30.1 2.82297 30.2411C8.39616 39.6003 20.3891 42.7514 29.8188 37.4134C22.5525 41.2229 8.23155 32.7102 12.2762 19.9883Z",
    fill: "url(#paint1_linear_1113_1387)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.99 27.7249C16.8389 26.7138 14.3463 24.3857 12.6532 21.0465C12.418 20.5997 12.3004 19.9413 12.4415 19.5415C12.3945 19.7061 12.324 19.8472 12.2769 20.0118C8.23225 32.7102 22.5532 41.2464 29.8195 37.4369C29.9606 37.3663 30.1017 37.2958 30.2428 37.2017C39.602 31.6285 42.7531 19.6356 37.4151 10.2058C41.2246 17.4486 32.712 31.7696 19.99 27.7249Z",
    fill: "url(#paint2_linear_1113_1387)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7262 19.9883C26.7151 23.1394 24.387 25.6321 21.0478 27.3252C20.601 27.5604 19.9426 27.6779 19.5428 27.5368C19.7074 27.5839 19.8485 27.6544 20.0131 27.7015C32.7115 31.7461 41.2477 17.4251 37.4146 10.1588C37.3441 10.0177 37.2735 9.87665 37.1795 9.73555C31.6063 0.399871 19.6133 -2.7277 10.1836 2.58682C17.4499 -1.2227 31.7709 7.28993 27.7262 19.9883Z",
    fill: "url(#paint3_linear_1113_1387)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1113_1387",
    x1: 28.3662,
    y1: 14.3358,
    x2: -0.304536,
    y2: 16.3406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#522583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1185,
    stopColor: "#522583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1209,
    stopColor: "#522583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2261,
    stopColor: "#62368C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4374,
    stopColor: "#7F5CA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6234,
    stopColor: "#977AB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7752,
    stopColor: "#A58EC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8736,
    stopColor: "#AB95C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B80B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1113_1387",
    x1: 14.3367,
    y1: 11.6298,
    x2: 16.3415,
    y2: 40.3006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#522583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1185,
    stopColor: "#522583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1209,
    stopColor: "#522583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2261,
    stopColor: "#62368C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4374,
    stopColor: "#7F5CA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6234,
    stopColor: "#977AB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7752,
    stopColor: "#A58EC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8736,
    stopColor: "#AB95C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B80B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1113_1387",
    x1: 11.6316,
    y1: 25.6597,
    x2: 40.302,
    y2: 23.6548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#522583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1185,
    stopColor: "#522583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1209,
    stopColor: "#522583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2261,
    stopColor: "#62368C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4374,
    stopColor: "#7F5CA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6234,
    stopColor: "#977AB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7752,
    stopColor: "#A58EC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8736,
    stopColor: "#AB95C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B80B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1113_1387",
    x1: 25.6609,
    y1: 28.3653,
    x2: 23.656,
    y2: -0.305291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#522583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1185,
    stopColor: "#522583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1209,
    stopColor: "#522583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2261,
    stopColor: "#62368C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4374,
    stopColor: "#7F5CA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6234,
    stopColor: "#977AB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7752,
    stopColor: "#A58EC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8736,
    stopColor: "#AB95C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B80B9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1113_1387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 215.121,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGt);
export default __webpack_public_path__ + "static/media/gt.38335c94905ea735c6c0b571923d01fc.svg";
export { ForwardRef as ReactComponent };